"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _reactRedux = require("react-redux");
var _reactDeviceDetect = require("react-device-detect");
var _reactI18next = require("react-i18next");
var _Hotel = _interopRequireDefault(require("../../../../../Hotel"));
var _actions = require("../../store/actions");
var _styles = _interopRequireDefault(require("./styles"));
var _stylesMap = _interopRequireDefault(require("./stylesMap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SimilarHotel = function SimilarHotel(_ref) {
  var currencyCode = _ref.currencyCode,
    _ref$disabledSelectio = _ref.disabledSelection,
    disabledSelection = _ref$disabledSelectio === void 0 ? false : _ref$disabledSelectio,
    hotelID = _ref.hotelID,
    _ref$percentageSimila = _ref.percentageSimilarity,
    percentageSimilarity = _ref$percentageSimila === void 0 ? 0 : _ref$percentageSimila,
    isEnabledCollectionsFeature = _ref.isEnabledCollectionsFeature,
    selected = _ref.selected;
  var hotelSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getHotel)(), [hotelID]);
  }, [hotelID]);
  var hotel = (0, _reactRedux.useSelector)(hotelSelector);
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var onSelect = (0, _react.useCallback)(function (isChecked) {
    return dispatch(isChecked ? (0, _actions.setActiveHotelById)(hotelID) : (0, _actions.detachActiveHotelById)(hotelID));
  }, [dispatch, hotelID]);
  return /*#__PURE__*/_react.default.createElement(_Hotel.default, _extends({
    compact: true,
    className: _styles.default.root,
    currency: currencyCode,
    averageRating: hotel.averageRating,
    city: hotel.city,
    country: hotel.country,
    district: hotel.district,
    hotelID: hotelID,
    isEnabledCollectionsFeature: isEnabledCollectionsFeature,
    isMobile: _reactDeviceDetect.isMobileOnly,
    name: hotel.name,
    photo: hotel.photos[0],
    secondaryStars: hotel.secondaryStars,
    services: hotel.services,
    sourceRatings: hotel.sourceRatings,
    stars: hotel.stars,
    watermark: hotel.watermark,
    stylesMap: _stylesMap.default,
    commentJSX: /*#__PURE__*/_react.default.createElement("span", {
      className: _styles.default.comment,
      dangerouslySetInnerHTML: {
        __html: t('SIMILAR_HOTEL_COMMENT', {
          number: percentageSimilarity
        })
      }
    })
  }, !disabledSelection && {
    selected: selected,
    onSelect: onSelect
  }));
};
SimilarHotel.propTypes = {
  currencyCode: _propTypes.default.string,
  disabledSelection: _propTypes.default.bool,
  hotelID: _propTypes.default.number.isRequired,
  selected: _propTypes.default.bool.isRequired,
  percentageSimilarity: _propTypes.default.number,
  isEnabledCollectionsFeature: _propTypes.default.bool
};
var _default = exports.default = SimilarHotel;